'use strict';

exports.__esModule = true;
exports.PrivateRoute = undefined;

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = require('react-router-dom');

var _ApiRest = require('../api/ApiRest');

var _querystring = require('querystring');

var _querystring2 = _interopRequireDefault(_querystring);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

var PrivateRoute = function PrivateRoute(_ref) {
  var Component = _ref.component,
      rest = _objectWithoutProperties(_ref, ['component']);

  if (rest.location.search) {
    var params = _querystring2.default.parse(rest.location.search);

    if (params['?id']) {
      var datosLocales = JSON.parse(decodeURI(atob(params['data']))); //console.log('datos locales privateroute',datosLocales);

      if (datosLocales.tokenSeps) {
        _ApiRest.ApiRest.guardarDatoLocal('tokenSeps', params['?id']);

        Object.keys(datosLocales).forEach(function (key) {
          if (key !== 'tokenSeps') {
            if (datosLocales[key] instanceof Object) {
              _ApiRest.ApiRest.guardarDatoLocal(key, JSON.stringify(datosLocales[key]));
            } else {
              _ApiRest.ApiRest.guardarDatoLocal(key, datosLocales[key]);
            }
          }
        });
      }
    }
  }

  return _react2.default.createElement(_reactRouterDom.Route, _extends({}, rest, {
    render: function render(props) {
      return _ApiRest.ApiRest.obtenerDatoLocal('tokenSeps') ? _react2.default.createElement(Component, props) : _react2.default.createElement(_reactRouterDom.Redirect, {
        to: {
          pathname: '/login',
          state: {
            from: props.location
          }
        }
      });
    }
  }));
};

exports.PrivateRoute = PrivateRoute;